import React from 'react';
import PropTypes from 'prop-types';

import { getPagePath, withLocales } from '@spotahome/bff/client';
import { localesShape } from '@spotahome/bff/shapes';

import { Footer as FooterComponent } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Heading.css';
import '@spotahome/ui-library/lib/components/footer/Footer.css';
import '@spotahome/ui-library/lib/components/LanguageSwitcher.css';
import '@spotahome/ui-library/lib/components/Link.css';
import '@spotahome/ui-library/lib/components/Separator.css';

import { updateURL } from '../utils/languageSwitcherUpdater';
import { SeoRoutingConsumer } from '../context/SeoRoutingContext';

import withAvailableLocales from './withAvailableLocales';

function handleHelpClick(e) {
  e.preventDefault();
  if (typeof zE !== 'undefined') {
    zE.activate({ hideOnClose: true });
  }
}

class Footer extends React.Component {
  static propTypes = {
    locales: PropTypes.shape(localesShape).isRequired,
    routing: PropTypes.shape({
      [PropTypes.string]: PropTypes.string
    }).isRequired
  };

  shouldComponentUpdate = () => false;

  handleChange = selectedLocale => {
    updateURL(selectedLocale, this.props.routing);
  };

  render() {
    const { routes } = this.props.locales;
    const localesKeys = Object.keys(routes);

    return (
      <FooterComponent
        links={{
          aboutUs: getPagePath('externals.landing-pages.about-us'),
          partners: getPagePath('externals.landing-pages.collaborators'),
          institutions: getPagePath('externals.landing-pages.institutions-list'),
          workWithUs: getPagePath('externals.landing-pages.work-with-us'),
          internships: getPagePath('externals.landing-pages.internships'),
          termsAndConditions: getPagePath('externals.landing-pages.terms-and-conditions'),
          cookiesPolicy: getPagePath('externals.landing-pages.cookies-policy'),
          privacyPolicies: getPagePath('externals.landing-pages.privacy-policies'),
          sitemap: getPagePath('externals.landing-pages.sitemap'),
          allRentableUnits: getPagePath('externals.landing-pages.sitemap-listings', { params: { rentableId: 1 } }),
          howItWorks: getPagePath('externals.landing-pages.how-it-works'),
          blog: getPagePath('externals.landing-pages.blog'),
          help: getPagePath('externals.landing-pages.help-center'),
          promotions: getPagePath('externals.landing-pages.promotions'),
          contactUs: getPagePath('externals.landing-pages.contact-us'),
          publishYourProperty: getPagePath('externals.landing-pages.list-your-property')
        }}
        help={{
          onClick: handleHelpClick
        }}
        locales={{
          current: this.props.locales.current,
          routes: localesKeys.reduce(
            (acc, key) => ({ ...acc, [key]: routes[key].path }),
            {}
          ),
          list: this.props.availableLocales,
          onChange: this.handleChange
        }}
      />
    );
  }
}

export default withAvailableLocales()(Footer);
